import React from "react";
import { Typography, Container } from "@material-ui/core";
import styles from "./styles";
import BusquedaIcono from "../../../assets/iconos/busqueda.png";
const SinResultado = ({ mensaje }) => {
    const classes = styles();

    const mensajeDefault = (
        <>
            No encontramos resultados para la búsqueda, intentalo de
            nuevo
        </>
    );

    return (
        <Container
            disableGutters={true}
            className={classes.container}
            maxWidth={false}
        >
            <img
                src={BusquedaIcono}
                alt="Busqueda"
                className={classes.imgBusqueda}
            />
            <Typography className={classes.texto}>
                {mensaje ?? mensajeDefault}
            </Typography>
        </Container>
    );
};

export default SinResultado;
